export default "__VITE_ASSET__CvtvNxkk__"